// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Jfa8A","bullet":"styles_bullet__AZXWd"};